import { render, staticRenderFns } from "./dspPrograms.vue?vue&type=template&id=0e433e30&scoped=true&"
import script from "./dspPrograms.vue?vue&type=script&lang=js&"
export * from "./dspPrograms.vue?vue&type=script&lang=js&"
import style0 from "./dspPrograms.vue?vue&type=style&index=0&id=0e433e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e433e30",
  null
  
)

export default component.exports